export default "<main class=\"container-fluid\">\n  <div class=\"row\">\n    \n  </div>\n</main>"